import { render, staticRenderFns } from "./RightVideo.vue?vue&type=template&id=178ec430&"
var script = {}
import style0 from "./RightVideo.vue?vue&type=style&index=0&id=178ec430&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports